__turbopack_context__.v({
  "calls": "pricing-mcp-plans-module__7uK4ea__calls",
  "eyebrow": "pricing-mcp-plans-module__7uK4ea__eyebrow",
  "grid": "pricing-mcp-plans-module__7uK4ea__grid",
  "note": "pricing-mcp-plans-module__7uK4ea__note",
  "overage": "pricing-mcp-plans-module__7uK4ea__overage",
  "price": "pricing-mcp-plans-module__7uK4ea__price",
  "section": "pricing-mcp-plans-module__7uK4ea__section",
});
